import {connect} from "react-redux";

import AccountModal from "../../components/Modals/AccountModal/AccountModal";
import {
    setAddressValue,
    setCityValue,
    setCPValue,
    setEmailValue,
    setNewPasswordValue,
    setPasswordValue,
    setPhoneValue,
    setVerifyPasswordValue,
    updateUserInfos
} from "../../actions/user";
import {setShowAccountModal} from "../../actions/modal";

const MapStateToProps = (state) => ({
    dataUser: state.user.dataUser,
    password: state.user.password,
    newPasswordValue: state.user.newPasswordValue,
    verifiedPassword: state.user.verifiedPassword,
    showAccountModal: state.modal.showAccountModal,
});

const MapDispatchToProps = (dispatch) => ({
    setEmailValue: (value) => {
        dispatch(setEmailValue(value));
    },
    setPhoneValue: (value) => {
        dispatch(setPhoneValue(value));
    },
    setCityValue: (value) => {
        dispatch(setCityValue(value));
    },
    setCPValue: (value) => {
        dispatch(setCPValue(value));
    },
    setAddressValue: (value) => {
        dispatch(setAddressValue(value));
    },
    setPasswordValue: (value) => {
        dispatch(setPasswordValue(value));
    },
    setNewPasswordValue: (value) => {
        dispatch(setNewPasswordValue(value));
    },
    setVerifyPasswordValue: (value) => {
        dispatch(setVerifyPasswordValue(value));
    },
    updateUserInfos: () => {
        dispatch(updateUserInfos());
    },
    setShowAccountModal: (bool) => {
        dispatch(setShowAccountModal(bool));
    },
});

export default connect(MapStateToProps, MapDispatchToProps)(AccountModal);